<template>
    <drag-dialog
        :append-to-body="true"
        :show.sync="dialog"
        :title="isAdd ? '新增员工' : '编辑员工'"
        :enableDrag="true"
        width="800px"
        @close="cancel">
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
    </drag-dialog>
</template>

<script>
    import {add, edit} from "@/api/user";
    import DragDialog from "@/components/DragDialog";
    import "@/components/dynamic-form";
    import {getDepts} from "@/api/dept";

    export default {
        props: {
            isAdd: {
                type: Boolean,
                required: true,
            },
            supThis: {
                type: Object
            }
        },
        components: {
            DragDialog
        },
        data() {
            return {
                loading: false,
                dialog: false,
                form: {},
                formConfig: {
                    formItemList: [
                        {
                            type: "input",
                            key: "name",
                            label: "姓名",
                            placeholder: "请输入姓名",
                            span: 12,
                            rules: [{required: true, message: "不能为空", trigger: "blur"}]
                        },
                        {
                            type: "input",
                            key: "code",
                            label: "编号",
                            span: 12,
                            placeholder: "请输入编号",
                            rules: [{required: true, message: "不能为空", trigger: "blur"}]
                        },
                        {
                            type: "input",
                            key: "account",
                            label: "用户账号",
                            span: 12,
                            placeholder: "请输入账号",
                            rules: [{required: true, message: "不能为空", trigger: "blur"}]
                        },
                        {
                            type: "number",
                            key: "phone",
                            label: "电话",
                            span: 12,
                            placeholder: "请输入电话",
                            rules: [{required: true, message: "不能为空", trigger: "blur"}]
                        },
                        {
                            type: "input",
                            key: "email",
                            label: "邮箱",
                            span: 12,
                            placeholder: "请输入邮箱"
                        },
                         {
                            type: "radio",
                            label: "性别",
                            span: 12,
                            key: "sex",
                            options: [
                              {
                                  label: "男",
                                  value: 0
                              },
                              {
                                  label: "女",
                                  value: 1
                              }
                          ],
                        },
                        // {
                        //     type: "radio",
                        //     label: "是否启用",
                        //     span: 12,
                        //     key: "enabled",
                        //     dicType: "ENABLE_STATUS",
                        //     optionsUrl: "/dict-detail",
                        //     rules: [{required: true,trigger: "change"}]
                        // },
                          {
                            type: "radio",
                            label: "是否启用",
                            span: 12,
                            value: true,
                            button: false,
                            border: false,
                            key: "enabled",
                            options: [
                                {
                                    label: '启用',
                                    value: true
                                },
                                {
                                    label: '禁用',
                                    value: false
                                }
                            ],
                            rules: [{required: true,trigger: "change"}]
                        },
                        {
                            type: "treeSelect",
                            label: "组织",
                            key: "deptId",
                            span: 12,
                            props: {
                                label: 'name',
                                value: 'id',
                                children: 'children'
                            },
                            options: []
                        },
                        // {
                        //     type: "select",
                        //     label: "职位",
                        //     key: "jobId",
                        //     cascade: 'deptId',
                        //     span: 12,
                        //     props: {
                        //         label: 'name',
                        //         value: 'id'
                        //     },
                        //   optionsUrl: '/job/select',
                        //   params: {deptId: ''}
                        // },
                        {
                          label: "员工",
                          key: "person",
                          type: "databox",
                          props: {
                            label: "name",
                            value: "id"
                          },
                          url: "/bs-person/getList",
                          tableColumn: [
                            {
                              property: "code",
                              label: "编码"
                            },
                            {
                              property: "name",
                              label: "名称",
                              query: {
                                type: "input"
                              }
                            }
                          ],
                          extendParms: { queryFieldItem: "id,code,name" },
                          multiple: false
                        },
                        {
                          type: "textarea",
                          key: "remark",
                          label: "描述",
                          placeholder: "请输入描述"
                        }
                        // {
                        //     type: "select",
                        //     label: "职位名称",
                        //     cascade: "org",
                        //     multiple: true,
                        //     key: "positions",
                        //     optionsUrl: 'api/pos',
                        //     params: {
                        //         org: ''
                        //     },
                        //     props: {
                        //         label: 'name',
                        //         value: 'id',
                        //     }
                        // }
                    ]
                }
            };
        },
        watch: {
            'supThis.treeData': {
                handler(val) {
                    this.formConfig.formItemList[7].options = val
                },
                deep: true
            }
        },
        methods: {
            loadss({node, resolve}) {
                this.deptId =
                    node.data instanceof Object
                        ? Array.isArray(node.data)
                        ? null
                        : node.data.id
                        : null;
                const params = {parentId: this.deptId};
                this.getDeptDatas(params).then(result => {
                    resolve(result);
                });
            },
            async getDeptDatas(params) {
                let result = [];
                await getDepts(params).then(res => {
                    result = res.data.content;
                });
                return Promise.resolve(result);
            },
            cancel() {
                this.resetForm();
            },
            doSubmit(val) {
                // val.positions = val.positions.map(item => {
                //     return {id: item}
                // })
                this.form = val
                if (this.isAdd) {
                    this.doAdd();
                } else this.doEdit();
            },
            doAdd() {
                if (this.form.person) {
                  this.form.personId = this.form.person.id
                }
                add(this.form)
                    .then(res => {
                        this.resetForm();
                        this.$notify({
                            title: "添加成功",
                            type: "success",
                            duration: 2500
                        });
                        this.loading = false;
                        this.supThis.dataTableInit();
                    })
                    .catch(err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            doEdit() {
                if (this.form.person) {
                  this.form.personId = this.form.person.id
                }
                edit(this.form)
                    .then(res => {
                        this.resetForm();
                        this.$notify({
                            title: "修改成功",
                            type: "success",
                            duration: 2500
                        });
                        this.loading = false;
                        this.supThis.dataTableInit();
                    })
                    .catch(err => {
                        this.loading = false;
                        console.log(err.response.data.message);
                    });
            },
            resetForm() {
                this.dialog = false;
                this.$refs.pageForm.resetForm();
            }
        }
    };
</script>

<style scoped>
</style>
